import { useState } from 'react';
import { container } from '../../../infrastructure/container';
import { CheckoutSessionData } from '../../../domain/subscription';

export const useStripeCheckout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createCheckoutSession = async (planId: string, planName: string, amount: number): Promise<CheckoutSessionData | null> => {
    setLoading(true);
    setError(null);

    try {
      const response = await container.subscriptionRepository.createCheckoutSession({
        planId,
        successUrl: `${window.location.origin}/subscription/success?session_id={CHECKOUT_SESSION_ID}`,
        cancelUrl: `${window.location.origin}/subscription/cancel`,
        mode: 'subscription',
        clientReferenceId: `plan_${planId}_${Date.now()}`,
      });
      
      if (response.status === 'success') {
        return response.data;
      } else {
        throw new Error(response.error.message || 'Failed to create checkout session');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to create checkout session';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const redirectToCheckout = async (planId: string, planName: string, amount: number): Promise<boolean> => {
    try {
      const checkoutSession = await createCheckoutSession(planId, planName, amount);
      
      if (!checkoutSession) {
        setError('Failed to create checkout session');
        return false;
      }

      // Redirect to Stripe Checkout
      console.log('Redirecting to Stripe Checkout:', checkoutSession.url);
      window.location.href = checkoutSession.url;
      
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Checkout failed';
      setError(errorMessage);
      return false;
    }
  };

  return {
    redirectToCheckout,
    createCheckoutSession,
    loading,
    error,
    clearError: () => setError(null),
  };
};
